import PagedTagCollection from './PagedTagCollection';

class FlowTagStore {
  collection = new PagedTagCollection();
}

export default new FlowTagStore();
